import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useI18nContext } from '../../hooks/I18nContext'

const MainNavigation: React.FC = () => {
  const location = useLocation()
  const { locale, setLocale, t } = useI18nContext()
  
  const navItems = [
    { label: t('nav.home'), href: '/' },
    { label: t('nav.start'), href: '/start' },
    { label: t('nav.learning'), href: '/learning' },
    { label: t('nav.support'), href: '/support' },
    { label: t('nav.buy'), href: '/buy' },
    { label: t('nav.about'), href: '/about' }
  ]

  const handleLanguageChange = (newLocale: 'zh' | 'en' | 'id') => {
    setLocale(newLocale)
  }

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="/images/logo.png" 
              alt="GENIUS AI" 
              className="w-20"
            />
          </Link>

          {/* Navigation Items */}
          <div className="hidden md:flex space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === item.href
                    ? 'text-white'
                    : 'text-gray-700 hover:text-gray-800 hover:bg-blue-50'
                }`}
                style={{
                  backgroundColor: location.pathname === item.href ? '#76C3D7' : 'transparent'
                }}
              >
                {item.label}
              </Link>
            ))}
          </div>

          {/* Language Selector */}
          <div className="flex items-center space-x-2">
            <button
              onClick={() => handleLanguageChange('zh')}
              className={`px-2 py-1 text-xs rounded transition-colors ${
                locale === 'zh' ? 'text-white' : 'text-gray-600 hover:bg-gray-100'
              }`}
              style={{
                backgroundColor: locale === 'zh' ? '#76C3D7' : 'transparent'
              }}
            >
              中文
            </button>
            <button
              onClick={() => handleLanguageChange('en')}
              className={`px-2 py-1 text-xs rounded transition-colors ${
                locale === 'en' ? 'text-white' : 'text-gray-600 hover:bg-gray-100'
              }`}
              style={{
                backgroundColor: locale === 'en' ? '#76C3D7' : 'transparent'
              }}
            >
              EN
            </button>
            <button
              onClick={() => handleLanguageChange('id')}
              className={`px-2 py-1 text-xs rounded transition-colors ${
                locale === 'id' ? 'text-white' : 'text-gray-600 hover:bg-gray-100'
              }`}
              style={{
                backgroundColor: locale === 'id' ? '#76C3D7' : 'transparent'
              }}
            >
              ID
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button className="text-gray-700 hover:text-blue-600">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default MainNavigation
